"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function validationCopiesExtractor(languages, VALIDATIONS_COPIES_KEY = 'VALIDATIONS') {
  Object.keys(languages).forEach(lang => {
    const validationsCopies = Object.keys(languages[lang]).filter(copyKey => copyKey.startsWith(`${VALIDATIONS_COPIES_KEY}.`)).map(key => {
      const val = languages[lang][key];
      const newKey = key.replace(`${VALIDATIONS_COPIES_KEY}.`, '');
      return {
        [newKey]: val
      };
    });
    const validations = Object.assign({}, ...Object.values(validationsCopies));
    Object.assign(languages[lang], {
      validations
    });
  });
}

var _default = validationCopiesExtractor;
exports.default = _default;